import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import "../../style/AllCarsAdmin.css";
import "../../style/VerificationRequests.css";
import { Spin } from "antd";
import VerificationUserModal from "../VerificationUserModal";

function VerificationRequests() {
  const { authToken, logout } = useAuth();
  const [username, setUsername] = useState("");
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedReq, setSelectedReq] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!authToken) {
        navigate("/");
        return;
      }
      try {
        const userRes = await api.get("usuario/getbyToken");
        setUsername(userRes.data.nombre);
        const res = await api.get("verification");
        setRequests(res.data.filter((r) => r.status === "pending"));
      } catch (err) {
        console.error("Error fetching requests:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [authToken, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleAction = async (id, action) => {
    try {
      await api.patch(`verification/${id}/${action}`, {});
      setRequests(requests.filter((req) => req._id !== id));
    } catch (err) {
      console.error("Error updating request:", err);
    }
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a verification-requests-page">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Solicitudes de verificación</p>
            {loading ? (
              <div className="vr-loading">
                <Spin size="large" />
              </div>
            ) : (
              <div className="vr-list">
                <div className="vr-header">
                  <span>Nombre</span>
                  <span>Identidad</span>
                  <span>Acciones</span>
                </div>
                {requests.length === 0 ? (
                  <p className="vr-empty">No hay solicitudes pendientes</p>
                ) : (
                  requests.map((req) => (
                    <div
                      className="vr-row"
                      key={req._id}
                      onClick={() => setSelectedReq(req)}
                    >
                      <span className="vr-name">{req.user?.nombre}</span>
                      <span className="vr-id">{req.numeroIdentidad}</span>
                      <div className="vr-actions">
                        <button
                          type="button"
                          className="vr-btn vr-btn--ghost"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(req.documento.url, "_blank");
                          }}
                        >
                          Ver Identidad
                        </button>
                        <button
                          type="button"
                          className="vr-btn vr-btn--approve"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAction(req._id, "approve");
                          }}
                        >
                          Aprobar
                        </button>
                        <button
                          type="button"
                          className="vr-btn vr-btn--reject"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAction(req._id, "reject");
                          }}
                        >
                          Rechazar
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
        {selectedReq && (
          <VerificationUserModal
            show={!!selectedReq}
            request={selectedReq}
            onClose={() => setSelectedReq(null)}
          />
        )}
        <div className="footer">
          <Foooter />
        </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default VerificationRequests;
